import './StepperProgress.2bfad379d313c841ea6beac6f2113a77.css';
export default {"progress":"_progress_18d3a_1"};